import Vue from 'vue';
import Router from 'vue-router';
import Login from './views/Login.vue';
import Public from './views/Public.vue';
import Licenses from './views/secure/Licenses.vue';
import License from './views/secure/License.vue';
import Disconnected from './views/Disconnected.vue';
import ChangePassword from './views/secure/ChangePassword.vue';
import About from './views/secure/About.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: {
        name: 'login' // poner home si no se quiere ir al login
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        public: true
      }
    },
    {
      path: '/disconnected',
      name: 'disconnected',
      component: Disconnected,
      meta: {
        public: true
      }
    },
    {
      path: '/home',
      name: 'home',
      component: Licenses,
      meta: {
        public: false
      }
    },
    {
      path: '/newlicense',
      name: 'newlicense',
      component: License,
      meta: {
        public: false
      }
    },
    {
      path: '/license/:idlicense',
      name: 'license',
      component: License,
      meta: {
        public: false
      }
    },
    {
      path: '/changepassword',
      name: 'changepassword',
      component: ChangePassword,
      meta: {
        public: false
      }
    },
    {
      path: '/about',
      name: 'about',
      component: About,
      meta: {
        public: false
      }
    },
    { path: '*', component: Public }
  ]
});
